import React, { useEffect, useState } from 'react';

import api from '../../services/api';
import { useToast } from '../../hooks/toast';

import { formataCPF, formataCNPJ } from '../../utils/funcoes';
import Loading from '../../components/Loading';
import getResponseErrors from '../../utils/getResponseErrors';

interface IPaciente {
  PacCodigo: number;
  PacNome: string;
  PacPessoaFisica: boolean;
  PacCPF: string;
  PacCNPJ: string;
  PacCPFFormatado: string;
  PacCNPJFormatado: string;
}

interface IDependente {
  DepCodigo: number;
  DepTitular: boolean;
  DepResponsavel: boolean;
  paciente: IPaciente;
  plano: {
    PlaCodigo: number;
    PlaNumero: string;
  };
}

interface IComponentProps {
  PlaCodigo: number;
}

const Etiqueta: React.FC<IComponentProps> = ({ PlaCodigo }) => {
  const { addToast } = useToast();
  const [loading, setLoading] = useState(false);
  const [titular, setTitular] = useState<IPaciente>();
  const [responsavel, setResponsavel] = useState<IPaciente>();
  const [dependentes, setDependentes] = useState<IPaciente[]>();
  const [plaNumero, setPlaNumero] = useState('');

  useEffect(() => {
    async function loadDados(): Promise<void> {
      setLoading(true);
      try {
        const response = await api.get<IDependente[]>(
          `/planos/etiqueta/${PlaCodigo}`,
        );

        const pacientesFormatados = response.data.map(dep => {
          return {
            ...dep,
            paciente: {
              ...dep.paciente,
              PacCPFFormatado: formataCPF(dep.paciente.PacCPF),
              PacCNPJFormatado: formataCNPJ(dep.paciente.PacCNPJ),
            },
          };
        });

        setTitular(
          pacientesFormatados.find(dep => dep.DepTitular === true)?.paciente,
        );
        setResponsavel(
          pacientesFormatados.find(dep => dep.DepResponsavel === true)
            ?.paciente,
        );
        setDependentes(
          pacientesFormatados
            .filter(
              dep => dep.DepTitular === false && dep.DepResponsavel === false,
            )
            .map(item => item.paciente),
        );

        setPlaNumero(pacientesFormatados[0]?.plano?.PlaNumero || '');
      } catch (error) {
        const mensagemErro = getResponseErrors(error);
        addToast({
          title: 'Não foi possível carregar adados da etiqueta',
          type: 'error',
          description: mensagemErro,
        });
      } finally {
        setLoading(false);
      }
    }
    loadDados();
  }, [PlaCodigo, addToast]);

  return (
    <div style={{ width: '6.2cm', fontSize: '10px' }}>
      {loading && <Loading />}
      {plaNumero && plaNumero !== '' && (
        <>
          <span>{`*Cartão ${plaNumero}*`}</span>
          <br />
        </>
      )}
      {responsavel && (
        <>
          <span>{`RESPONSÁVEL: ${responsavel.PacNome}`}</span>
          <br />
          <span>
            {responsavel.PacPessoaFisica
              ? `CPF: ${responsavel.PacCPFFormatado}`
              : `CNPJ: ${responsavel.PacCNPJFormatado}`}
          </span>
          <br />
        </>
      )}
      {titular && (
        <>
          <span>{`TITULAR: ${titular.PacNome}`}</span>
          <br />
          <span>
            {titular.PacPessoaFisica
              ? `CPF: ${titular.PacCPFFormatado}`
              : `CNPJ: ${titular.PacCNPJFormatado}`}
          </span>
          <br />
        </>
      )}
      {dependentes && dependentes.length > 0 && (
        <span>
          DEPENDENTES:{' '}
          {dependentes.map(dep => (
            <span key={dep.PacCodigo.toString()}>
              {dep.PacNome} <br />
            </span>
          ))}
        </span>
      )}
    </div>

    // <div className="p-0 m-0 bg-white">
    //   {plano && parcelas && titular && tipo === 'carne' && (
    //     <Carne
    //       PlaNumero={plano.PlaNumero}
    //       titular={titular}
    //       responsavel={responsavel}
    //       parcelas={parcelas}
    //       qtdDependentes={dependentesAtivos?.length || 0}
    //     />
    //   )}

    //   {plano && parcelas && titular && tipo === 'contrato' && (
    //     <Contrato
    //       PlaDataInicio={plano.PlaDataInicio}
    //       PlaValor={plano.PlaValor}
    //       dataParcela1={parcelas[0].CprDataVenc}
    //       DepCodigo={titular.DepCodigo}
    //     />
    //   )}

    //   {plano && titular && tipo === 'etiqueta' && (
  );
};

export default Etiqueta;
